package com.evoapps.evoshift.review

/** No store on the web: the app never asks for a rating there (SH-240). */
actual fun platformStoreReviewLauncher(): StoreReviewLauncher = StoreReviewLauncher.None
